module.exports = __webpack_public_path__ + "img/exel.f7987a0d.svg";